export const OPERATIONS_DISABILITY = 'pgpro_operations_disability_in_portal';
export const HOME_AND_AUTO_FUNNEL = 'pgpro_operations_home_insurance_in_portal';
export const EAPP_INTERVIEW = 'pgpro_eapp_interview';
export const PRODUCT_OFFERINGS = 'advisor_growth_product_offerings';
export const HIDE_EMAIL_CSV = 'pgpro_release_hide_email_csv_button';
export const EXPORT_ESTIMATES_CTA = 'advisor-portal-export-estimates-cta';
